export default __webpack_public_path__ + "static/media/GlobalNotice WEB.34ba6684.png";